<template>
  <div v-if="checkIfVLM()">
    <Window v-if="isReady"/>
    <AboutVlm/>
  </div>
  <div v-else>
    <Window v-if="isReady"/>
    <About/>
  </div>
</template>

<script>
  import 'styles/index.scss';
  import Window from 'components/Window';
  import About from 'components/About';
  import AboutVlm from 'components/AboutVlm';
  import { getQueryStringParams } from 'lib/utils';

  export default {
    name: 'App',
    components: {
      Window,
      About,
      AboutVlm,
    },
    data() {
      return {
        isReady: false
      };
    },
    mounted() {
      window.onresize = function () {
        document.body.height = window.innerHeight;
      };
      window.onresize();

      window.parent && window.parent.postMessage('amy:ready', '*');
      setTimeout(() => {
        this.isReady = true;
      }, 300);
    },
    methods: {
      checkIfVLM(){
        const params = getQueryStringParams(); 
        return params && params['shoppingSlug'] === 'vlm';
      }
    }
  };
</script>
